import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, message, Popconfirm, Space, Input, TimePicker, Select, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { strDate2Server } from "@extensions/convert";
import dayjs from "dayjs";

const Record = ({id, defaultItem, onClose, users}) => {
  const [item, setItem] = useState({...defaultItem});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onValuesChange = value => setItem({...item, ...value});
  const onCancel = () => onClose(false);

  const onSave = () => {
    const newItem = {...item, docDate: strDate2Server(item.docDate), datePlan: strDate2Server(item.datePlan), };
    if (item.startDt && item.datePlan) {
      // В startDt дату заменить на date
      const date = item.datePlan;
      const startTime = newItem.startDt.format('HH:mm');
      newItem.startDt = dayjs(`${date.format('YYYY-MM-DD')}T${startTime}`).format('YYYY-MM-DDTHH:mm') + ":00.000Z";
    }
    else newItem.startDt = null;
    if (item.finishDt && item.datePlan) {
      // В finishDt дату заменить на date
      const date = item.datePlan;
      const finishTime = newItem.finishDt.format('HH:mm');
      newItem.finishDt = dayjs(`${date.format('YYYY-MM-DD')}T${finishTime}`).format('YYYY-MM-DDTHH:mm') + ":00.000Z";
    }
    else newItem.finishDt = null;
    setLoading(true);
    serverFetch("plan/doc", { method: id ? "PUT" : "POST", bodyData: newItem})
      .then(() => onClose(true))
      .catch(e => { setLoading(false); message.error(e.userMessage); });
  };

  const onDelete = () => {
    setLoading(true);
    serverFetch(`plan/doc/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => { setLoading(false); message.error(e.userMessage); });
  };

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`plan/doc/${id}`)
        .then(data => {
          const data2 = {
            ...data, 
            docDate: data.docDate ? dayjs(data.docDate) : null, 
            datePlan: data.datePlan ? dayjs(data.datePlan) : null, 
            startDt: dayjs(data.startDt), 
            finishDt: dayjs(data.finishDt)
          };
          setLoading(false);
          setItem(data2);
          form.setFieldsValue(data2);
        })
        .catch(e => { setLoading(false); message.error(e.userMessage); });
    } else form.setFieldsValue({...defaultItem, cnts: []});
  };
  console.log(users)
  useEffect(getData, [id, form, defaultItem]);

  return <div className="misoft-modal">
    <div className="misoft-modal-overlay" onClick={e => e.target === e.currentTarget && onCancel()}>
      <div className="misoft-modal-content">
        <div className="misoft-modal-title" style={{marginBottom: 0}}>
          <span>Запись</span>
          <CloseOutlined
            className="misoft-section-title-close" 
            onClick={() => onClose()} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
          <Form.Item name="datePlan" label="Дата">
            <DatePicker value={item.datePlan} onChange={(date) => setItem({...item, datePlan: date})} format="DD.MM.YYYY" />
          </Form.Item>
          <Form.Item name="startDt" label="Время начала">
            <TimePicker format="HH:mm" />
          </Form.Item>
          <Form.Item name="finishDt" label="Время окончания">
            <TimePicker format="HH:mm" />
          </Form.Item>
          <Form.Item name="predName" label="Клиент">
            <Input value={item.predName} onChange={(e) => setItem({...item, predName: e.target.value})} />
          </Form.Item>
          <Form.Item name="predAddress" label="Адрес">
            <Input value={item.predAddress} onChange={(e) => setItem({...item, predAddress: e.target.value})} />
          </Form.Item>
          <Form.Item name="predPhone" label="Телефон">
            <Input value={item.predPhone} onChange={(e) => setItem({...item, predPhone: e.target.value})} />
          </Form.Item>
          <Form.Item name="userId" label="Исполнитель">
            <Select value={item.userId} onChange={(value) => setItem({...item, userId: value})} placeholder="Выберите исполнителя">
              {users?.map(user => <Select.Option key={user.id} value={user.id}>{user.name}</Select.Option>)}
            </Select>
          </Form.Item>
          <Form.Item name="comment" label="Комментарий">
            <Input.TextArea value={item.comment} onChange={(e) => setItem({...item, comment: e.target.value})} rows={3} />
          </Form.Item>
          <Form.Item name="osn" label="Основание">
            <Input value={item.osn} onChange={(e) => setItem({...item, osn: e.target.value})} />
          </Form.Item>
          <Form.Item label=" ">
            <Space>
              <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}>
                <Button className="sport-btn" disabled={!id}>Удалить</Button>
              </Popconfirm>
              <Button className="sport-btn" onClick={onSave}>Сохранить</Button>
              <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>
}

export default Record;